import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button';
import OptionalLifeInsuranceModal from './OptionalLifeInsuranceModal';

const OptionalLifeInsuranceModalDemo = () => {
  const [showOptionalLifeInsuranceModal, setShowOptionalLifeInsuranceModal] =
    React.useState<boolean>(false);

  const handleShowOptionalLifeInsuranceModal = () =>
    setShowOptionalLifeInsuranceModal(true);
  const handleCloseOptionalLifeInsuranceModal = () =>
    setShowOptionalLifeInsuranceModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Optional Life Insurance Modal</h4>
        <Button onMouseDown={handleShowOptionalLifeInsuranceModal}>
          Open Modal
        </Button>
        <OptionalLifeInsuranceModal
          showOptionalLifeInsuranceModal={showOptionalLifeInsuranceModal}
          handleCloseOptionalLifeInsuranceModal={
            handleCloseOptionalLifeInsuranceModal
          }
        />
      </Container>
    </Container>
  );
};

export default OptionalLifeInsuranceModalDemo;
